// pages/LoyaltyQRPage.jsx
import React from "react";
import LoyaltyQRDashboard from "./LoyaltyQRDashboard"; // путь к вашему дашборду

const LoyaltyQRPage = ({ token }) => {
  // Если токен нужен для API запросов внутри дашборда
  return <LoyaltyQRDashboard token={token} />;
};

export default LoyaltyQRPage;